var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"courseD flex-layout"},[_c('div',{staticClass:"courseDimg"},[_c('img',{attrs:{"src":_vm.itemData.image}})]),_c('div',{staticClass:"narrate"},[_c('p',[_vm._v("目标：")]),_c('p',[_vm._v(_vm._s(_vm.itemData.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }